module.exports = __webpack_public_path__ + "static/media/trimex_xaley.56ec6786.png";